<template>
  <header class="header">
    <div class="container clearfix">
      <a class="logo-ascenti" :class="{'logo-locked': locked}" :href="routes.home.name" @click.prevent="goHome">
        <img src="../../assets/img/logos/logo-ascenti.svg" alt="Ascenti Logo">
      </a>
      <a class="logo-ascenti-mobile" :class="{'logo-locked': locked}" :href="routes.home.name" @click.prevent="goHome">
        <img src="../../assets/img/logos/logo-ascenti-mobile.svg" alt="Ascenti Logo">
      </a>

      <div class="hamburger" :class="{'open': isActive}"  @click="isActive = !isActive">
        <div></div>
        <div></div>
        <div></div>
      </div>

      <nav class="navigation" :class="{'open': isActive}">
        <ul>
          <li><a href="https://www.ascenti.co.uk/treatment">Pay as you go</a></li>
           <li><a :href="bookingUrl">Visit a clinic</a></li>
          <li><a :href="bookingVideoUrl">Video appointment</a></li>
          <li><a class="active" :href="routes.home.name" @click.prevent="goHome">Symptom checker</a></li>
        </ul>
      </nav>

      <nav class="secondary-navigation">
        <ul>
          <li><a href="#">Help</a></li>
          <li><a :href="bookingUrl">Skip to appointment booking</a></li>
        </ul>
      </nav>


    </div>
  </header>
</template>

<script>
import {mapState} from "vuex"

export default {
  name: 'Top',

  data() {
    return {
      isActive: false
    }
  },

  computed: {
    ...mapState("survey", [
      "surveyComplete",
      "postingTriageData",
    ]),

    bookingUrl() {
      return process.env.VUE_APP_BOOKING_URL;
    },

    bookingVideoUrl() {
      return `${process.env.VUE_APP_BOOKING_URL}/video`;
    },

    locked() {
      return this.surveyComplete || !this.userName;
    },

    shouldShowHelpLink() {
      return !this.$route.name || !window._.includes([
        this.routes.help.name,
      ], this.$route.name);
    },

    shouldShowAppointmentsLink() {
      return !this.$route.name || !window._.includes([
        this.routes.appointments.name,
        this.routes.appointmentBooked.name,
      ], this.$route.name);
    },

  },

  methods: {
    goHome() {
      if (!this.locked) {
        this.$router.push(this.routes.home);
      }
    },
  },
}
</script>

<style lang="scss">
  .header .secondary-navigation {
    display: none;
  }

  body.survey\.step-1,
  body.survey\.step-2,
  body.survey\.step-3,
  body.survey\.step-4 {
    .header .navigation, .header .hamburger {
      display: none
    }

    @include screen(sm) {
      .header .secondary-navigation {
        display: flex;
        align-items: center;
        margin-left: auto;
        float: right;

        li {
          border-right: 1px solid $color-dove-gray;
          display: inline;
          font-size: 16px;
          line-height: 19px;
          padding-right: 15px;
          padding-left: 15px;

          &:last-child {
            border-right: none;
            padding-right: 15px;
          }

          a {
            color: $color-dove-gray;
          }
        }
      }
    }
  }

  // Tiny screens
  .header {
    margin-bottom: 1.5rem;

    .container {
      padding: 20px 0;

      @include screen(md) {
        padding: 0;
        display: flex;
      }
    }

    .loading {
      width: 20px;
      height: 20px;
      vertical-align: bottom;
    }

    .logo-ascenti {
      display: none;

      @include screen(md) {
        display: block;
        float: left;
      }
    }

    .logo-ascenti-mobile {
      display: block;
      float: left;
      
      @include screen(md) {
        display: none;
      }
    }

    .hamburger {
      width: 40px;
      height: 30px;
      float: right;
      cursor: pointer;
      position: relative;
      transform: rotate(0deg);
      transition: .5s ease-in-out;
      z-index: 110;

      @include screen(md) {
        display: none;
      }

      div {
        display: block;
        position: absolute;
        opacity: 1;
        left: 0;
        transform: rotate(0deg);
        transition: .25s ease-in-out;
        background: $color-outrageous-orange;
        height: 6px;
        width: 100%;
        border-radius: 6px;

        &:nth-child(1) {
          top: 0px;
          transform-origin: left center;
        }

        &:nth-child(2) {
          top: 12px;
          transform-origin: left center;
        }

        &:nth-child(3) {
          top: 24px;
          transform-origin: left center;
        }
      }

      &.open div {
          background: $color-white;
        }

      &.open div:nth-child(1) {
        transform: rotate(45deg);
        top: -2px;
        left: 6px;
      }

      &.open div:nth-child(2) {
        width: 0%;
        opacity: 0;
      }

      &.open div:nth-child(3) {
        transform: rotate(-45deg);
        top: 26px;
        left: 5px;
      }
    }

    .navigation {
      display: none;
      position: absolute;
      width: 100vw;
      height: 100vh;
      background: linear-gradient(to right,#ffccf6 0%,#ff7ea2 50%,#ff8b02 100%);
      z-index: 99;
      margin-top: -20px;
      margin-left: -20px;

      &.open {
        display: block;
      }

      @include screen(md) {
        display: block;
        float: left;
        display: flex;
        align-items: center;
        position: static;
        width: auto;
        height: auto;
        background: $color-white;
        z-index: 0;
        margin-top: 0;
        margin-left: 0;
      }

      ul {
        margin: 70px auto;
        max-width: 320px;
        text-align: center;

        @include screen(md) {
          margin: 0;
          max-width: none;
          text-align: left;
        }
      }

      li {
        font-size: $nav-font-size;
        display: block;
        font-weight: bold;
        font-size: 32px;
        margin-top: 12px;
        margin-bottom: 12px;

        @include screen(md) {
          font-weight: normal;
          display: inline;
          font-size: 18px;
          margin-left: 36px;
        }

        @include screen(lg) {
          margin-left: 68px;
          font-size: $nav-font-size;
        }

        a {
          text-decoration: none;
          color: $color-white;

          @include screen(md) {
            color: $color-chathams-blue;
          }

          &.active, &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
